import { customAlphabet } from "nanoid";
import { alphanumeric } from "nanoid-dictionary";

export const genid = customAlphabet(alphanumeric, 16);
